import "react-notifications-component/dist/theme.css"
import "react-notifications/lib/notifications.css"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import moment from "moment"
import Swal from "sweetalert2"
import UIfx from "uifx"
import { Button, Snackbar, SnackbarContent } from "@material-ui/core"
import { useSnackbar } from "notistack"
import {
  acceptLegalAgreement,
  checkLegalAgreement,
} from "src/services/complexServices"
import { useHistory } from "react-router-dom"
import {
  getComplex,
  selectCamaraGarita,
  selectConjunto,
  selectModules,
} from "src/redux/slices/complexSlice"
import { Check, Close } from "@material-ui/icons"
import { Store } from "react-notifications-component"
import SplashScreen from "src/components/Common/SplashScreen"
import AlertGarita from "src/components/layout/AlertGarita"
import CamarasConjunto from "src/components/layout/CamarasConjunto"
import Account from "src/components/Topbar/Account"
import GuardiaNotifications from "src/components/Topbar/notifications/GuardiaNotifications"
import axiosInstance from "src/utils/axios"
import { selectUser } from "src/redux/slices/authSlice"
import throttle from "lodash/throttle"
import * as FirestoreService from "../../views/viewGuardia/alertas/services/firestore"
import tickAudio from "../../views/viewGuardia/alertas/mySounds/police.mp3"
import { Brand, ComplexSwitcher, GaritaLabel } from "./shared"

const tick = new UIfx(tickAudio, {
  volume: 1.0,
  throttleMs: 100,
})

export const End = () => (
  <>
    <ComplexSwitcher />
    <GaritaLabel />
    <GuardiaNotifications />
    <CamarasConjunto />
    <Account />
  </>
)

export const Effects = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const camaraGarita = useSelector(selectCamaraGarita)
  const user = useSelector(selectUser)
  const conjunto = useSelector(selectConjunto)
  const users = useSelector(state => state.complex.users)
  const modulos = useSelector(selectModules)
  const [loading, setLoading] = useState(true)
  const [openSnack, setOpenSnack] = useState(false)
  const [dataAlert, setDataAlert] = useState({})
  const [loadingPermitir, setLoadingPermitir] = useState(false)

  const handleOpenSnack = (data, id) => {
    setDataAlert({ data, id })
    setOpenSnack(true)
  }

  const handleCloseSnack = () => {
    setDataAlert({})
    setOpenSnack(false)
  }

  useEffect(() => {
    const fetchLegalAgreement = async () => {
      if (user.id) {
        const checkLegal = await checkLegalAgreement(user.id)
        if (!checkLegal) {
          const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success",
            },
            buttonsStyling: false,
          })
          swalWithBootstrapButtons
            .fire({
              title: "Términos y Condiciones",
              html: `
                <p style="text-align: justify;">
                  Para continuar, por favor revisa nuestros 
                  <a href="https://www.tglabsecuador.com/mi-casita#comp-krgvr8r7" target="_blank" style="color: #007bff; text-decoration: none;">
                  Términos y Condiciones.
                  </a><br/>
                </p>
                <label style="display: flex; align-items: center; gap: 8px;">
                  <input type="checkbox" id="acceptTerms">
                  <span>He leído y acepto los términos y condiciones de uso.</span>
                </label>`,
              imageUrl:
                "https://cdn-icons-png.flaticon.com/512/10348/10348844.png",
              imageWidth: 150,
              imageHeight: 150,
              confirmButtonText: "Continuar",
              allowOutsideClick: false,
              allowEscapeKey: false,
              showCloseButton: false,
              didOpen: () => {
                const confirmButton = Swal.getConfirmButton()
                const checkbox = document.getElementById("acceptTerms")
                confirmButton.disabled = true
                checkbox?.addEventListener("change", e => {
                  confirmButton.disabled = !e.target.checked
                })
              },
            })
            .then(async result => {
              const isChecked = document.getElementById("acceptTerms").checked
              if (result.isConfirmed) {
                if (isChecked) {
                  try {
                    const data = {
                      AceptaAcuerdoLegal: true,
                      fecha: moment(Date.now()).toLocaleString(),
                    }
                    await acceptLegalAgreement(user.id, data)
                  } catch (error) {
                    enqueueSnackbar(
                      "Error al actualizar los términos y condiciones.",
                      { variant: "error" }
                    )
                  }
                }
              }
            })
        }
      }
    }
    fetchLegalAgreement()
  }, [conjunto.id])

  const listenAlert = (idConjunto, playAlert) => {
    let hasAlert = false
    const unsuscriber = FirestoreService.getAlerta(
      {
        next: querySnapshot => {
          const alert = querySnapshot.docs[0] || null
          setLoading(false)

          if (alert) {
            hasAlert = true
            playAlert()
            playAlert.cancel()
            enqueueSnackbar("Ayuda!!!", {
              variant: "error",
              preventDuplicate: true,
            })
            const swalWithBootstrapButtons = Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success",
                cancelButton: "btn btn-danger",
              },
              buttonsStyling: false,
            })

            let alertMessage = `${alert.data().DatosUsuario}\n${
              alert.data().Detalle
            }`

            const alertOriginComplex = alert.ref.path.split("/")[1]
            if (user.complexs.length > 0) {
              const originComplex = user.complexs?.find(
                complex => complex.uid === alertOriginComplex
              )
              if (originComplex) {
                alertMessage += `\nen el conjunto ${originComplex.nombre}`
              }
            }

            swalWithBootstrapButtons
              .fire({
                title: "Necesito ayuda",
                text: alertMessage,
                icon: "error",
                imageUrl: alert.data().Imagen,
                imageWidth: 400,
                imageHeight: 200,
                confirmButtonText: "Detalle",
              })
              .then(result => {
                if (result.isConfirmed) {
                  if (user.complexs.length > 0) {
                    dispatch(getComplex(alertOriginComplex)).unwrap()
                  }
                  history.push("/guardia/alerta")
                }
              })
          }
        },
        error: () => {
          enqueueSnackbar("Error al obtener registro de alertas", {
            variant: "error",
          })
        },
      },
      idConjunto
    )
    return { unsuscriber, hasAlert }
  }

  const enviarCorreo = async (values, params) => {
    try {
      if (!params.get("correo")) {
        return
      }
      const body = {
        id_conjunto: conjunto.id,
        imagen_conjunto: "",
        residente_nombre: `${values.nombre_destino} ${values.apellido_destino}`,
        residente_casa: values.casa_destino,
        tipo: "seguridad",
        fecha_hora: new Date(),
        asunto: "Notificación de acceso [no-reply]",
        evento: values.tipo_visita,
        motivo: values.tipo_visita,
        observacion: values.observaciones_entrada,
        visitante_nombre: `${values.nombre_persona_ingreso} ${values.apellido_persona_ingreso}`,
        visitante_dni: values.cedula_persona_ingreso,
        visitante_placa: values.placa_vehiculo_ingreso,
        visitante_placa_color: values.color_vehiculo_ingreso,
        fotos: [
          values.imagen_rostro,
          values.imagen_vehiculo,
          values.imagen_cedula,
        ],
        destinatario: params.get("correo"),
        correo: conjunto?.CorreoPersonalizado || undefined,
      }

      const { status } = await axiosInstance.post(
        "correo/enviar_correos_seguridad/",
        body
      )

      if (status === 200) {
        enqueueSnackbar("Se envió correo de notificación.", {
          variant: "success",
        })
      }
    } catch (err) {
      enqueueSnackbar("Error al enviar correo de notificación.", {
        variant: "error",
      })
    }
  }

  const closeQrAlert = () => {
    setLoadingPermitir(true)
    FirestoreService.deleteVisitaAnticipadaQrByConjunto(
      conjunto.id,
      dataAlert.id
    )
      .then(() => {
        setLoadingPermitir(false)
        handleCloseSnack()
      })
      .catch(() => {})
  }

  const permitirEntrada = async () => {
    setLoadingPermitir(true)
    const visitaSnapshot = await FirestoreService.getVisitaAnticipadaByHash(
      conjunto.id,
      dataAlert.data.Hash
    )
    const visitaDoc = visitaSnapshot.docs[0]
    const visitaAnticipada = { id: visitaDoc.id, ...visitaDoc.data() }
    const selectedUser = users.find(us => visitaAnticipada.DestinoId === us.id)
    const params = new URLSearchParams({
      tipo_entrada: 1,
      nombre_persona_ingreso: visitaAnticipada?.Nombre,
      apellido_persona_ingreso: visitaAnticipada?.Apellido,
      cedula_persona_ingreso: visitaAnticipada?.Cedula.trim(),
      placa_vehiculo_ingreso: visitaAnticipada?.PlacaVehiculo || "",
      color_vehiculo_ingreso: visitaAnticipada?.ColorVehiculo || "",
      nombre_destino:
        visitaAnticipada?.DestinoId === "Otro" ? "" : selectedUser?.Nombre,
      apellido_destino:
        visitaAnticipada?.DestinoId === "Otro" ? "" : selectedUser?.Apellido,
      casa_destino:
        visitaAnticipada?.DestinoId === "Otro"
          ? visitaAnticipada?.LugarDestinoOtro
          : selectedUser?.Casa,
      id_destino:
        visitaAnticipada?.DestinoId === "Otro" ? "" : selectedUser?.idUser,
      id_conjunto: conjunto.id,
      tipo_visita: visitaAnticipada?.TipoVisita,
      tiempo_estimado_salida:
        visitaAnticipada?.TiempoEstimadoSalida &&
        visitaAnticipada?.TiempoEstimadoSalida !== "Indefinido"
          ? visitaAnticipada?.TiempoEstimadoSalida
          : "",
      observaciones_entrada: `${visitaAnticipada?.Observacion || ""}`,
      correo:
        visitaAnticipada?.DestinoId === "Otro" ? "" : selectedUser?.Correo,
      camaraGarita,
      isRezy: modulos.isRezy || false,
    })
    const res = await axiosInstance.post(
      `api/bitacora_digital/${conjunto.id}/`,
      params
    )
    if (res.status === 200) {
      enqueueSnackbar(
        <>
          ¡Error en el registro!
          <br />
          No se ha registrado una última salida para este usuario
        </>,
        {
          variant: "error",
        }
      )
      handleCloseSnack()
      setLoadingPermitir(false)
      return
    }
    if (res.status === 201) {
      enqueueSnackbar("Registro ingresado con éxito", {
        variant: "success",
      })
      await FirestoreService.updateEstadoVisita(
        conjunto.id,
        visitaAnticipada.id,
        true
      )
      try {
        await axiosInstance.post("qrcode/envia_push/", {
          titulo: "Ingreso de visita",
          mensaje: `Tu visita ${visitaAnticipada?.Nombre} ${visitaAnticipada?.Apellido} acaba de llegar.`,
          tokens_dispositivo: selectedUser?.tokens || [],
        })
        setLoadingPermitir(false)
        handleCloseSnack()
      } catch (error) {
        if (error.response) {
          // eslint-disable-next-line no-console
          console.error(
            "Error en la respuesta del servidor:",
            error.response.status
          )
        }
        setLoadingPermitir(false)
        handleCloseSnack()
      }
      await FirestoreService.deleteVisitaAnticipadaQrByConjunto(
        conjunto.id,
        dataAlert.id
      )
      enviarCorreo(res.data, params)
      handleCloseSnack()
    }
  }

  useEffect(() => {
    let unsuscribers = []
    let isMounted = true
    const playAlert = throttle(tick.play, 60000, { trailing: false })
    if (isMounted) {
      if (user.complexs?.length > 0) {
        unsuscribers = user.complexs.map(complex =>
          listenAlert(complex.uid, playAlert)
        )
      } else {
        const suscriber = listenAlert(user.ConjuntoUidResidencia, playAlert)
        unsuscribers.push(suscriber)
      }
    }

    return () => {
      playAlert.cancel()
      unsuscribers.forEach(res => {
        res?.unsuscriber?.()
      })
      isMounted = false
      setLoading(true)
    }
  }, [conjunto.id])

  useEffect(() => {
    const unsub = FirestoreService.getVisitaAnticipadaQrByConjunto(
      {
        next: query => {
          query.docChanges().forEach(change => {
            if (change.type === "added") {
              const alertQr = change.doc.data()
              if (!alertQr) return
              const isTodayAlert = moment(
                alertQr.TiempoEntrada.toDate()
              ).isBetween(moment().startOf("day"), moment().endOf("day"))
              if (isTodayAlert) {
                handleOpenSnack(alertQr, change.doc.id)
              }
            }
          })
        },
      },
      conjunto.id,
      camaraGarita
    )
    return unsub
  }, [camaraGarita, conjunto])

  useEffect(() => {
    const unsub = FirestoreService.getEntradaCA(
      {
        next: query => {
          query.docs.forEach(doc => {
            const data = doc.data()
            const notificacion = {
              title: "Entrada por Control de Acceso",
              message: data.Mensaje,
              type: "success",
              container: "top-left",
            }
            Store.addNotification({
              ...notificacion,
              onRemoval: async () => {
                await FirestoreService.deleteEntradaCA(doc.id)
              },
              dismiss: {
                duration: 2000,
                onScreen: true,
                pauseOnHover: true,
                showIcon: true,
              },
            })
          })
        },
      },
      conjunto.id
    )

    return unsub
  }, [conjunto.id])

  if (loading) {
    return <SplashScreen />
  }

  return (
    <>
      <Snackbar
        open={openSnack}
        autoHideDuration={dataAlert.data?.Tipo === "warning" ? 20000 : 5000}
        onClose={() => handleCloseSnack()}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <SnackbarContent
          style={{
            backgroundColor: (() => {
              if (dataAlert.data?.Tipo === "warning") return "#d32f2f"
              if (dataAlert.data?.Tipo === "success") return "#43a047"
              return "#092147"
            })(),
            padding: "16px",
          }}
          message={
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div>
                <h6>{dataAlert.data?.Titulo}</h6>
                {dataAlert.data?.Mensaje}
                <br />
              </div>
              <div
                style={{
                  marginTop: "12px",
                  display: "flex",
                  gap: "8px",
                }}
              >
                {dataAlert.data?.Tipo === "warning" && (
                  <Button
                    variant="outlined"
                    size="small"
                    disabled={loadingPermitir}
                    style={{
                      color: "black",
                      borderColor: "white",
                      backgroundColor: "white",
                    }}
                    onClick={() => {
                      permitirEntrada()
                    }}
                  >
                    <Check fontSize="small" /> Aprobar la entrada
                  </Button>
                )}
                <Button
                  variant="outlined"
                  size="small"
                  style={{
                    color: "black",
                    borderColor: "white",
                    backgroundColor: "white",
                  }}
                  onClick={() => {
                    closeQrAlert()
                  }}
                >
                  <Close fontSize="small" /> Cerrar
                </Button>
              </div>
            </div>
          }
        />
      </Snackbar>
      <AlertGarita />
    </>
  )
}

export { Brand }
